import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetcher } from '../../../lib/api-fetcher';

export interface MfaStatus {
  enabled: boolean;
}

export interface MfaEnrollment {
  success: boolean;
  secret: string;
  otpauthUrl: string;
}

export interface MfaVerification {
  success: boolean;
  verified: boolean;
}

const mfaKey = ['settings', 'mfa'] as const;

export function useMfaStatus() {
  return useQuery({
    queryKey: mfaKey,
    queryFn: () => fetcher.get<MfaStatus>('/staff/v1/settings/mfa/status'),
  });
}

/** Generates and stores a fresh secret; stays inactive until verify succeeds. */
export function useEnableMfa() {
  return useMutation({
    mutationFn: () => fetcher.post<MfaEnrollment>('/staff/v1/settings/mfa/enable', {}),
  });
}

/** Confirms a code against the pending secret, activating MFA for the account. */
export function useVerifyMfa() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => fetcher.post<MfaVerification>('/staff/v1/settings/mfa/verify', { code }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mfaKey });
    },
  });
}

export function useDisableMfa() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (code: string) => fetcher.post<{ success: boolean }>('/staff/v1/settings/mfa/disable', { code }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: mfaKey });
    },
  });
}
